import { Roles, type Role } from "./roles";

/** Roles an actor can manage, including their own role. */
export const MANAGEABLE_ROLES_BY_ROLE: Record<Role, readonly Role[]> = {
  [Roles.SUPERADMIN]: [Roles.SUPERADMIN, Roles.OWNER, Roles.ADMIN, Roles.PROFESSIONAL, Roles.RECEPTIONIST, Roles.SECRETARY],
  [Roles.OWNER]: [Roles.OWNER, Roles.ADMIN, Roles.PROFESSIONAL, Roles.RECEPTIONIST, Roles.SECRETARY],
  [Roles.ADMIN]: [Roles.ADMIN, Roles.PROFESSIONAL, Roles.RECEPTIONIST, Roles.SECRETARY],
  [Roles.PROFESSIONAL]: [Roles.PROFESSIONAL, Roles.RECEPTIONIST],
  [Roles.RECEPTIONIST]: [Roles.RECEPTIONIST],
  [Roles.SECRETARY]: [Roles.SECRETARY],
  [Roles.PATIENT]: [],
};

export function manageableRoles(role: Role): readonly Role[] {
  return MANAGEABLE_ROLES_BY_ROLE[role];
}

export function canManageRole(actorRole: Role, targetRole: Role): boolean {
  return manageableRoles(actorRole).includes(targetRole);
}

/**
 * Patient invitations are clinic membership flows, not staff-role management.
 * Keeping this separate prevents a generic patient role from leaking into
 * staff-only permission checks.
 */
const PATIENT_INVITATION_MANAGERS: readonly Role[] = [
  Roles.SUPERADMIN,
  Roles.OWNER,
  Roles.ADMIN,
  Roles.PROFESSIONAL,
  Roles.RECEPTIONIST,
  Roles.SECRETARY,
];

export function canManageInvitationRole(
  actorRole: Role,
  targetRole: Role,
): boolean {
  if (targetRole === Roles.PATIENT) {
    return PATIENT_INVITATION_MANAGERS.includes(actorRole);
  }

  return canManageRole(actorRole, targetRole);
}

/** Compatibility name for role-based route guards. */
export const hasRequiredRole = canManageRole;
